import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import { useTheme } from '../contexts/ThemeContext';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = authService.getCurrentUser();
  const isAdmin = authService.isAdmin();
  const { darkMode, toggleDarkMode } = useTheme();
  const [adminMenuOpen, setAdminMenuOpen] = useState(false);
  const adminMenuRef = useRef(null);

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (adminMenuRef.current && !adminMenuRef.current.contains(event.target)) {
        setAdminMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Close dropdown when route changes
  useEffect(() => {
    setAdminMenuOpen(false);
  }, [location.pathname]);

  if (!user) return null;

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');
  const isAdminActive = () => location.pathname.startsWith('/admin');

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        Payroll Shift Schedule Organizer
      </div>
      <div className="navbar-menu">
        <Link to="/dashboard" className={'navbar-link' + (isActive('/dashboard') ? ' active' : '')}>
          Dashboard
        </Link>
        <Link to="/shifts" className={'navbar-link' + (isActive('/shifts') ? ' active' : '')}>
          Shift Records
        </Link>
        {isAdmin && (
          <div className="navbar-dropdown" ref={adminMenuRef}>
            <button 
              className={'navbar-link navbar-dropdown-toggle' + (isAdminActive() ? ' active' : '')}
              onClick={() => setAdminMenuOpen(!adminMenuOpen)}
            >
              Admin <span style={{ fontSize: '10px', marginLeft: '4px' }}>{adminMenuOpen ? '▲' : '▼'}</span>
            </button>
            {adminMenuOpen && (
              <div className="navbar-dropdown-menu">
                <Link to="/admin" className="navbar-dropdown-item">
                  User Management
                </Link>
                <Link to="/admin/audit-logs" className="navbar-dropdown-item">
                  Audit Logs
                </Link>
                <Link to="/admin/files" className="navbar-dropdown-item">
                  Uploaded Files
                </Link>
                <Link to="/admin/settings" className="navbar-dropdown-item">
                  System Settings
                </Link>
              </div>
            )}
          </div>
        )}
        <Link to="/settings" className={'navbar-link' + (isActive('/settings') ? ' active' : '')}>
          Settings
        </Link>
        <button onClick={toggleDarkMode} className="theme-toggle" title={darkMode ? 'Light Mode' : 'Dark Mode'}>
          {darkMode ? '☀️' : '🌙'}
        </button>
        <div className="user-info">
          <span className="user-name">{user.name}</span>
          <span className="user-role">{user.role}</span>
          <button onClick={handleLogout} className="btn btn-secondary btn-sm">
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
